import React from 'react'
import CtaButton from 'components/ui/CtaButton'

const AboutUsSection = ({ openForm }: { openForm: () => void }) => {
  return (
    <div className="relative w-full bg-white">
      <div className="relative px-4 pt-10 pb-8 sm:px-6 lg:pb-24 lg:px-8 md:max-w-screen-lg mx-auto">
        <h2 className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          Producing engaging and immersive customer experiences with amazing
          food truck brands nationwide
        </h2>
        <div className="my-10 space-y-6 text-gray-700 prose lg:prose-lg md:max-w-screen-lg mx-auto text-justify">
          <p>
            BFT utilizes our nationwide network of mobile vendors, municipal
            partners and regional food truck associations to create and simplify
            Experiential Marketing Experiences for your clients and customers.
            There is no better way to make customers happy than with made to
            order onsite food. From our in-house design firm and truck wrapping
            partners across the Nation, we’ll help craft your experience with
            world class service and engaging locations.
          </p>
          <p>
            Through our partnership with the National Food Truck Association we
            have years of experience with regional and statewide regulations and
            permits. Our team hasn’t just pulled permits, we’ve also been
            intimately involved with positive regulation changes. From a small
            three hour parking space permit to the large scale City event
            allowance. We’ve engaged and cooperated with every type of
            municipality throughout the United States.
          </p>
          <p>
            The BFT platform with over 5000 vendors and hundreds of regional
            partners, allows us to quickly and easily build an immersive
            experience for your clients and customers. We use the pieces we’ve
            assembled to help you build the experience you’re looking for.
          </p>
        </div>
        <div className="mx-auto max-w-max mt-10">
          <CtaButton onClick={openForm}>Activate Now</CtaButton>
        </div>
      </div>
    </div>
  )
}

export default AboutUsSection
